import { Calendar } from '@phosphor-icons/react';

export default Calendar;
